/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DnR API
 * 地方自治体事業管理システムAPI
 * OpenAPI spec version: 1.0.0
 */

import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { ErrorType } from '../../../../shared/api/custom-instance';

import { customInstance } from '../../../../shared/api/custom-instance';
import type { ErrorResponse, TokenAdditionListResponse, TokenUsageResponse } from './model';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * 現在の集計期間のトークン使用量を取得する
 * @summary トークン使用量取得
 */
export const getTokenUsage = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<TokenUsageResponse>(
    { url: `/ai-logs/token-usage`, method: 'GET', signal },
    options,
  );
};

export const getGetTokenUsageQueryKey = () => {
  return [`/ai-logs/token-usage`] as const;
};

export const getGetTokenUsageQueryOptions = <
  TData = Awaited<ReturnType<typeof getTokenUsage>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTokenUsage>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTokenUsageQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTokenUsage>>> = ({ signal }) =>
    getTokenUsage(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTokenUsage>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTokenUsageQueryResult = NonNullable<Awaited<ReturnType<typeof getTokenUsage>>>;
export type GetTokenUsageQueryError = ErrorType<ErrorResponse>;

export function useGetTokenUsage<
  TData = Awaited<ReturnType<typeof getTokenUsage>>,
  TError = ErrorType<ErrorResponse>,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTokenUsage>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTokenUsage>>,
          TError,
          Awaited<ReturnType<typeof getTokenUsage>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTokenUsage<
  TData = Awaited<ReturnType<typeof getTokenUsage>>,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTokenUsage>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTokenUsage>>,
          TError,
          Awaited<ReturnType<typeof getTokenUsage>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTokenUsage<
  TData = Awaited<ReturnType<typeof getTokenUsage>>,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTokenUsage>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary トークン使用量取得
 */

export function useGetTokenUsage<
  TData = Awaited<ReturnType<typeof getTokenUsage>>,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTokenUsage>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTokenUsageQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * ログインユーザーのテナントに紐づくトークン追加履歴を取得する。金額情報は含まれない。
 * @summary トークン追加一覧取得
 */
export const listTokenAdditions = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<TokenAdditionListResponse>(
    { url: `/ai-logs/token-additions`, method: 'GET', signal },
    options,
  );
};

export const getListTokenAdditionsQueryKey = () => {
  return [`/ai-logs/token-additions`] as const;
};

export const getListTokenAdditionsQueryOptions = <
  TData = Awaited<ReturnType<typeof listTokenAdditions>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTokenAdditions>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListTokenAdditionsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listTokenAdditions>>> = ({ signal }) =>
    listTokenAdditions(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listTokenAdditions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListTokenAdditionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listTokenAdditions>>
>;
export type ListTokenAdditionsQueryError = ErrorType<ErrorResponse>;

export function useListTokenAdditions<
  TData = Awaited<ReturnType<typeof listTokenAdditions>>,
  TError = ErrorType<ErrorResponse>,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTokenAdditions>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTokenAdditions>>,
          TError,
          Awaited<ReturnType<typeof listTokenAdditions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListTokenAdditions<
  TData = Awaited<ReturnType<typeof listTokenAdditions>>,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listTokenAdditions>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTokenAdditions>>,
          TError,
          Awaited<ReturnType<typeof listTokenAdditions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListTokenAdditions<
  TData = Awaited<ReturnType<typeof listTokenAdditions>>,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTokenAdditions>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary トークン追加一覧取得
 */

export function useListTokenAdditions<
  TData = Awaited<ReturnType<typeof listTokenAdditions>>,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTokenAdditions>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListTokenAdditionsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
